import { render } from "./appUserRedirect.vue?vue&type=template&id=2250f6d0"
import script from "./appUserRedirect.vue?vue&type=script&lang=js"
export * from "./appUserRedirect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__